import { render } from "./AggregateTableGroupBy.vue?vue&type=template&id=28d21328"
import script from "./AggregateTableGroupBy.vue?vue&type=script&lang=js"
export * from "./AggregateTableGroupBy.vue?vue&type=script&lang=js"

import "./AggregateTableGroupBy.vue?vue&type=style&index=0&id=28d21328&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__